import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { HelpCircle, ArrowRight, Eye, EyeOff } from "lucide-react";
import api from "../../lib/api";
import { Reveal } from "./Reveal";

export const QuestionOfDay = () => {
  const [q, setQ] = React.useState(null);
  const [revealed, setRevealed] = React.useState(false);

  React.useEffect(() => {
    api.get("/daily-questions/question-of-the-day").then((r) => setQ(r.data)).catch(() => {});
  }, []);

  if (!q) return null;

  return (
    <section className="bg-night text-cream grain-overlay" data-testid="question-of-day-section">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <Reveal>
          <div className="flex items-center gap-2 mb-4">
            <HelpCircle className="w-4 h-4 text-gold" />
            <p className="uppercase tracking-[0.25em] text-xs text-gold-soft">Question of the Day · Ìbéèrè t'òní</p>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight mb-10">Daily Reflection · Ìrònú</h2>
        </Reveal>

        <Reveal delay={0.08}>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-gold/30 bg-night-surface p-8 md:p-12"
            data-testid="question-of-day-card"
          >
            {q.theme && (
              <span className="text-[10px] uppercase tracking-widest border border-cream/25 rounded-full px-2.5 py-0.5 text-cream/60">
                {q.theme}
              </span>
            )}
            <p className="font-serif text-2xl md:text-3xl text-gold leading-snug mt-6" data-testid="question-of-day-text">
              {q.question}
            </p>

            {q.answer && q.answer_visible && (
              <div className="mt-8">
                {!revealed ? (
                  <button
                    onClick={() => setRevealed(true)}
                    data-testid="question-of-day-reveal"
                    className="inline-flex items-center gap-2 bg-gold text-night text-sm font-semibold px-6 py-3 rounded-full hover:bg-gold-light transition-colors"
                  >
                    <Eye className="w-4 h-4" /> Reveal the meaning
                  </button>
                ) : (
                  <AnimatePresence>
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      transition={{ duration: 0.4 }}
                      className="rounded-2xl bg-forest/30 border border-gold/25 p-6"
                      data-testid="question-of-day-answer"
                    >
                      <p className="uppercase tracking-[0.2em] text-[11px] text-gold-soft mb-2">Ìtumọ̀ · Meaning</p>
                      <p className="text-cream/85 text-lg leading-relaxed">{q.answer}</p>
                      <button
                        onClick={() => setRevealed(false)}
                        data-testid="question-of-day-hide"
                        className="mt-4 inline-flex items-center gap-1.5 text-sm text-gold hover:text-gold-light transition-colors"
                      >
                        <EyeOff className="w-4 h-4" /> Hide
                      </button>
                    </motion.div>
                  </AnimatePresence>
                )}
              </div>
            )}

            <Link
              to="/daily-question"
              data-testid="question-of-day-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
            >
              See more daily questions
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default QuestionOfDay;
